import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { queryAfterMeApplys, saveFlowTrack, getFormCate } from '@/services/form';
import moment from 'moment';
var now = moment();
var startDate = now.clone().subtract(183, 'days').format('YYYY-MM-DD');
var endDate = now.clone().endOf('month').format('YYYY-MM-DD');
var columns = [{
  title: '申请流水号',
  dataIndex: 'fillId',
  align: 'center',
  width: 20
}, {
  title: '标题',
  dataIndex: 'formName',
  scopedSlots: {
    customRender: 'formName'
  },
  ellipsis: true,
  align: 'center',
  resizable: true,
  width: 30
}, {
  title: '',
  dataIndex: '',
  ellipsis: true,
  align: 'center',
  resizable: true,
  width: 5,
  scopedSlots: {
    customRender: 'trackStatus'
  }
}, {
  title: '类型',
  dataIndex: 'category',
  ellipsis: true,
  align: 'center',
  width: 15
}, {
  title: '申请人',
  dataIndex: 'startUserName',
  ellipsis: true,
  align: 'center',
  resizable: true,
  width: 30
}, {
  title: '申请时间',
  dataIndex: 'startTime',
  ellipsis: true,
  align: 'center',
  width: 20
}, {
  title: '接收时间',
  dataIndex: 'createTime',
  ellipsis: true,
  align: 'center',
  width: 20
}, {
  title: '当前审批节点',
  dataIndex: 'taskName',
  ellipsis: true,
  align: 'center',
  width: 20
}, {
  title: '概述',
  dataIndex: 'summary',
  width: 20
},
// {
//     title: '审核状态',
//     dataIndex: 'status',
//     ellipsis: true,
//     align: 'center',
//     width: 15,
//     scopedSlots: { customRender: 'getTagColor' }
// },
{
  title: '操作',
  dataIndex: '',
  align: 'center',
  width: 15,
  scopedSlots: {
    customRender: 'action'
  }
}];
export default {
  name: 'AfterMyApplys',
  components: {},
  data: function data() {
    return {
      visible: false,
      visibleId: '',
      expand: false,
      loading: false,
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      advanced: false,
      columns: columns,
      dataSource: [],
      selectedRows: [],
      total: 0,
      pagination: {
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        total: this.total,
        pageSizeOptions: ['10', '20', '30', '40', '100'],
        showTotal: function showTotal(total) {
          return "\u5171 ".concat(total, " \u6761\u6570\u636E");
        },
        onShowSizeChange: this.pageSizeChange,
        onChange: this.pageChange
      },
      form: {
        pageSize: 10,
        currentNo: 1
      },
      formState: {
        summary: '',
        fillId: '',
        formName: undefined,
        timeValue: [startDate, endDate],
        category: undefined
      },
      cateList: []
    };
  },
  authorize: {
    deleteRecord: 'delete'
  },
  methods: {
    //表格行点击事件
    rowClick: function rowClick(record, index) {
      var _this = this;
      return {
        on: {
          dblclick: function dblclick() {
            _this.$router.push({
              path: '/formReview/reviewCenter/viewProcess',
              query: {
                procInsId: record.procInsId
              }
            });
          }
        }
      };
    },
    dbTwoClick: function dbTwoClick(row) {
      this.$router.push({
        path: '/formReview/reviewCenter/viewProcess',
        query: {
          procInsId: row.procInsId
        }
      });
    },
    handleVisibleChange: function handleVisibleChange(row) {
      // if (row.trackStatus == 2) {
      //     this.visible = true;
      // }
    },
    handlepopConfirmConfirm: function handlepopConfirmConfirm(row) {
      var _this2 = this;
      saveFlowTrack(row).then(function (res) {
        _this2.visible = false;
        _this2.onClicAfterMeApplyList();
      });
    },
    handlepopConfirmCancel: function handlepopConfirmCancel() {
      this.visible = false;
    },
    getTagColor: function getTagColor(type) {
      var _colors$find;
      var colors = [{
        itemVal: 'rgba(255, 152, 6, 0.8)',
        itemKey: '3'
      }, {
        itemVal: 'rgba(255, 152, 6, 0.8)',
        itemKey: '2'
      }, {
        itemVal: 'rgba(79, 191, 73, 0.8)',
        itemKey: '1'
      }, {
        itemVal: 'rgba(220, 33, 39, 0.8)',
        itemKey: '6'
      }, {
        itemVal: 'rgba(24, 144, 255, 0.8)',
        itemKey: '0'
      }];
      return (_colors$find = colors.find(function (item) {
        return item.itemKey == type;
      })) === null || _colors$find === void 0 ? void 0 : _colors$find.itemVal;
    },
    getTagMsg: function getTagMsg(type) {
      var _msg$find;
      var msg = [{
        itemVal: '驳　回',
        itemKey: '3'
      }, {
        itemVal: '通　过',
        itemKey: '1'
      }, {
        itemVal: '不通过',
        itemKey: '6'
      }];
      return (_msg$find = msg.find(function (item) {
        return item.itemKey == type;
      })) === null || _msg$find === void 0 ? void 0 : _msg$find.itemVal;
    },
    getForm: function getForm() {
      var _this3 = this;
      getFormCate().then(function (res) {
        // const { data: list } = res.data;
        _this3.cateList = res.data.data;
      });
    },
    cz: function cz() {
      this.$refs.searchFrom.resetFields();
      this.loadData();
    },
    toggle: function toggle() {
      this.expand = !this.expand;
    },
    toSave: function toSave(row) {
      var _this4 = this;
      this.visibleId = row.taskId;
      if (row.trackStatus == 2) {
        this.visible = true;
      } else {
        this.visible = false;
        saveFlowTrack(row).then(function (res) {
          _this4.onClicAfterMeApplyList();
        });
      }
    },
    toggleAdvanced: function toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    pageSizeChange: function pageSizeChange(val, pageNum) {
      this.loading = true;
      this.pagination.pageSize = pageNum;
      this.pagination.current = 1;
      this.form.pageSize = this.pagination.pageSize;
      this.form.currentNo = this.pagination.current;
      this.onClicAfterMeApplyList(); //获取列表数据
    },
    pageChange: function pageChange(page, val) {
      this.loading = true;
      this.pagination.current = page;
      this.form.pageSize = this.pagination.pageSize;
      this.form.currentNo = this.pagination.current;
      sessionStorage.setItem('Pagination_afterMeApplication', JSON.stringify(this.pagination));
      this.onClicAfterMeApplyList(); //获取列表数据
    },
    queryTableList: function queryTableList() {
      this.form.currentNo = 1;
      this.pagination.current = 1;
      this.onClicAfterMeApplyList();
      sessionStorage.removeItem('Pagination_afterMeApplication');
    },
    onClicAfterMeApplyList: function onClicAfterMeApplyList() {
      var _this5 = this;
      this.loading = true;
      queryAfterMeApplys({
        formName: this.formState.formName,
        category: this.formState.category,
        beginTime: this.formState.timeValue[0],
        endTime: this.formState.timeValue[1],
        summary: this.formState.summary,
        fillId: this.formState.fillId,
        pageSize: this.form.pageSize,
        currentNo: this.form.currentNo
      }).then(function (res) {
        var data = res.data.data;
        _this5.dataSource = data && Object.prototype.hasOwnProperty.call(data, 'rows') ? data.rows : [];
        _this5.total = data && Object.prototype.hasOwnProperty.call(data, 'total') ? data.total : 0;
        _this5.pagination.total = _this5.total;
      }).finally(function () {
        _this5.loading = false;
      });
    },
    loadData: function loadData() {
      this.onClicAfterMeApplyList();
    },
    onViewAfterMeApply: function onViewAfterMeApply(text, record) {
      this.$router.push({
        path: '/formReview/reviewCenter/viewProcess',
        query: {
          procInsId: record.procInsId
        }
      });
    }
  },
  created: function created() {
    var savedPagination = sessionStorage.getItem('Pagination_afterMeApplication');
    if (savedPagination) {
      try {
        var parsed = JSON.parse(savedPagination);
        this.pagination.current = parsed.current || 1;
        this.pagination.pageSize = parsed.pageSize || 10;
      } catch (e) {} finally {}
    }
    this.loadData();
    this.getForm();
  }
};